import { render, staticRenderFns } from "./UpgradeStepHeader.vue?vue&type=template&id=99fb7bfe&scoped=true&"
import script from "./UpgradeStepHeader.vue?vue&type=script&lang=js&"
export * from "./UpgradeStepHeader.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeStepHeader.vue?vue&type=style&index=0&id=99fb7bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99fb7bfe",
  null
  
)

export default component.exports